import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { createQueryParamsFromApiFilters } from "helpers/utility/savedViewsUtils";
import {
  PAGE_PARAMETER,
  SAVED_VIEW_PARAMETER,
} from "helpers/constants/miscellaneous";
import { SavedView } from "types";

const useNavigateToView = () => {
  const navigate = useNavigate();
  const { viewsDatasetId, datasetId } = useParams();

  const navigateToView = useCallback(
    (view: SavedView) => {
      let url = `/dataset/${viewsDatasetId || datasetId}/data`;
      if (view.filters.cluster_id) {
        url = url + `/cluster/${view.filters.cluster_id}`;
      }
      const queryParams = createQueryParamsFromApiFilters(view.filters);
      const hasPageParam = queryParams.includes(`${PAGE_PARAMETER}=`);

      url = url + queryParams;

      // Add page parameter if not already present
      if (!hasPageParam) {
        url += (queryParams.length > 1 ? "&" : "") + `${PAGE_PARAMETER}=1`;
      }

      url += `&${SAVED_VIEW_PARAMETER}=${view.id}`;
      navigate(url);
    },
    [navigate, viewsDatasetId, datasetId]
  );

  return navigateToView;
};

export default useNavigateToView;
